import React from "react";
import _data from "../../data";

class Promo2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      promo2: {},
      trustedCompany: []
    };
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
    this.setState({
      promo2: _data.promo2,
      trustedCompany: _data.trustedCompany
    });
  }

  render() {
    return (
      <React.Fragment>
        {/* start promo section */}
        <section className="promo-section mt-5 ptb-100">
          <div className="container">
            <div className="row justify-content-between pb-100">
              <div className="col-md-12">
                <div className="client-section-wrap d-flex flex-row align-items-center">
                  <p className="lead mr-5 mb-0">Trusted by companies like:</p>
                  <ul className="list-inline justify-content-between">
                    {(this.state.trustedCompany || []).map((company, index) => {
                      return (
                        <li className="list-inline-item" key={index}>
                          <img
                            src={company}
                            width="85"
                            alt="client"
                            className="img-fluid"
                          />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>

            <div className="row equal">
              {(this.state.promo2.items || []).map((item, index) => {
                return (
                  <div className="col-md-4 col-lg-4" key={index}>
                    <div className="single-promo single-promo-hover text-center gray-light-bg h-100">
                      <div>
                        <img
                          src={item.image}
                          alt="promo"
                          className="img-fluid img-full-box"
                        />
                      </div>
                      <div className="p-4">
                        <h5>{item.title}</h5>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
        {/* end hero section */}
      </React.Fragment>
    );
  }
}

export default Promo2;
